'use strict';

require('../../style/index.less');

require('../../grid/style/index.less');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/row/style/index.js
// module id = 13
// module chunks = 0